// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-background[data-v-46022d5e] {\n  background-color: #f7f7f7;\n  padding: 1%;\n}", ""]);
// Exports
module.exports = exports;
